/**
 * Utility function to search on Amazon with tab reuse functionality
 * @param gameTitle - The game title to search for
 */
export const searchOnAmazon = (gameTitle: string) => {
    const amazonUrl = `https://www.amazon.nl/s?k=${encodeURIComponent(gameTitle)}`

    // Try to find an existing Amazon tab
    const existingTab = window.open('', 'amazon-search-tab')

    if (existingTab && !existingTab.closed) {
        // Reuse existing tab
        existingTab.location.href = amazonUrl
        existingTab.focus()
    } else {
        // Open new tab with a specific name for future reuse
        window.open(amazonUrl, 'amazon-search-tab', 'noopener,noreferrer')
    }
} 